const thumbnailElements = document.querySelectorAll('.post-thumbnail');
const buttonsContainers = document.querySelectorAll('.thumbnail-buttons');

if (
    buttonsContainers &&
    buttonsContainers.length > 0 &&
    thumbnailElements &&
    thumbnailElements.length > 0
) {
    buttonsContainers.forEach((btnsContainer, index) => {
        const thumbnailElement = thumbnailElements[index];
        const buttons = btnsContainer.querySelectorAll('button');
        let currentActiveIndex = 0; // To keep track of the currently active button

        if (buttons && thumbnailElement) {
            // Function to update the thumbnail
            const updateThumbnail = (thumbnailUrl) => {
                thumbnailElement.style.backgroundImage = `url("${thumbnailUrl}")`;
            };

            // Function to change the active button
            const changeActiveButton = () => {
                // Remove 'active' class from all buttons
                for (let i = 0; i < buttons.length; i++) {
                    buttons[i].classList.remove('active');
                }

                // Set 'active' class on the new button and update the thumbnail
                buttons[currentActiveIndex].classList.add('active');
                updateThumbnail(buttons[currentActiveIndex].getAttribute('data-thumbnail'));

                // Update the index for the next button
                currentActiveIndex = (currentActiveIndex + 1) % buttons.length;
            };

            // Add click event to each button
            for (let i = 0; i < buttons.length; i++) {
                buttons[i].addEventListener('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    currentActiveIndex = i; // Update the current index to the clicked button
                    changeActiveButton(); // Change to the clicked button
                });
            }

            // Check if the element has the 'auto-animate' class
            if (thumbnailElement.classList.contains('auto-animate')) {
                // Set initial active button
                changeActiveButton();

                // Set up an interval for automatic animation
                setInterval(changeActiveButton, 4500); // Change every 4.5 seconds (4500ms)
            }
        }
    });
}
